$(function() {
  $(".pure-menu").hover(menuMouseOver, menuMouseOut);
  return $(".pure-menu-heading").on('touchstart', menuTouch);
});

menuMouseOver = function() {
  return $(this).find('.pure-menu-list').removeClass('hidden');
};

menuMouseOut = function() {
  return $(this).find('.pure-menu-list').addClass('hidden');
};

menuTouch = function() {
  return $(this).siblings().closest('.pure-menu-list').toggleClass('hidden');
};